var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60211 7.10681C1.04509 6.51907 0.749997 5.74132 0.781172 4.94317C0.814236 3.95071 1.21283 3.0027 1.90454 2.27135C2.59625 1.53999 3.53519 1.07382 4.55078 0.95752H5.0869C6.01351 0.976139 6.90941 1.28345 7.64245 1.83413C8.37548 2.3848 8.90682 3.14967 9.15808 4.01589C9.32732 4.55663 9.6711 5.03021 10.1387 5.36676C10.6063 5.7033 11.1729 5.88498 11.7549 5.88498C12.337 5.88498 12.9036 5.7033 13.3712 5.36676C13.8387 5.03021 14.1825 4.55663 14.3518 4.01589C14.6065 3.17438 15.1234 2.43011 15.8314 1.88539C16.5394 1.34066 17.4037 1.02221 18.3057 0.973791H18.4732C19.6152 0.973791 20.7103 1.41427 21.5178 2.19834C22.3253 2.9824 22.7789 4.04582 22.7789 5.15465C22.759 5.87899 22.4601 6.56974 21.9412 7.09053L11.7884 17.9575L1.60211 7.10681Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH);
export default __webpack_public_path__ + "static/media/h.ddb81136d2cc7201a005098940e0ac0e.svg";
export { ForwardRef as ReactComponent };